<template lang="html">
    <section class="section vraag w100 clearfix">
        <div class="w100">
            <label class="question" :class="[required ? 'required' : '']" :for="'input-'+name"><h4>{{ label }}</h4></label>
        </div>
        <div class="w50 input" :class="[error ? 'error-text' : '']">
                <datepicker
                    class="gt-form-text"
                    :class="[error ? 'error' : '']"
                    :name="name"
                    :config="options"
                    v-model="date"
                    autocomplete="off"
                ></datepicker>
                <div class="error-icon d-none">!</div>
                <div class="tooltip bottom">
                    <div class="tooltip-arrow"></div>
                    <div class="tooltip-inner">{{ error }}</div>
                </div>
        </div>
    </section>
</template>

<script>
//plugin datepicker
//https://www.npmjs.com/package/@shopmacher/vue-bootstrap-datetimepicker
//https://getdatepicker.com/4/Options/

//imports datepicker
import jQuery from 'jquery'
import Datepicker from 'vue-bootstrap-datetimepicker';

//icons datepicker
jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
    icons: {
        time: 'fa fa-clock',
        date: 'fa fa-calendar',
        up: 'fa fa-arrow-up',
        down: 'fa fa-arrow-down',
        previous: 'fa fa-chevron-left',
        next: 'fa fa-chevron-right',
        today: 'fa fa-calendar-check',
        clear: 'fa fa-trash-alt',
        close: 'fa fa-times-circle'
    }
});

export default {
    components: {
        Datepicker
    },
    props: {
        label: String,
        name: String,
        options: Object,
        value: String,
        error: String,
        required: Boolean,
    },
    computed: {
        date: {
            get() { return this.value },
            set(date) { this.$emit('input', date)}
        }
    }
}
</script>

<style lang="scss">
//scss datepicker
@import 'pc-bootstrap4-datetimepicker/src/sass/bootstrap-datetimepicker-build';

//fix form-control in current design
input.form-control {
    display: inline-block;
    width: 100%;
    height: auto;
    padding: 8px;
    font-size: 1.5rem;
    font-weight: 400;
    line-height: inherit;
    color: inherit;
    background-color: #F5F5F5;
    background-clip: initial;
    border: 1px solid #B2B2B2;
    border-radius: 0;
    transition: none;
}
</style>